import React, { Component } from 'react';
//import LoginForm from "../forms/LoginForm";
import LoginSignUpForm from "./../forms/LoginSignUpForm";
 

class LoginPage extends Component {
  state = {  }
  render() { 
    return (  
     
          <LoginSignUpForm />
      
    );
  }
}

export default LoginPage;